var React = require('react');

function F1 (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"F1"),React.createElement("g",{"style":{"isolation":"isolate"},"key":1},[React.createElement("polygon",{"points":"49.06 20.75 47.71 0 0 3.29 14.15 23.49 49.06 20.75","fill":"#f47643","style":{"mixBlendMode":"multiply"},"key":0}),React.createElement("polygon",{"points":"0 3.09 0 23.88 0 32.71 0 53.5 0 83.12 23.07 83.12 23.07 62.33 23.07 53.5 49.06 53.5 49.06 32.71 23.07 32.71 23.07 21.09 0 3.09","fill":"#73c9bd","style":{"mixBlendMode":"multiply"},"key":1})])]);
}

F1.defaultProps = {"viewBox":"0 0 49.06 83.12"};

module.exports = F1;

F1.default = F1;
